export default function afterComa(price) {
    let result
    let dotIdx = price.indexOf(".")
    let resultPrice = price.slice(dotIdx)
    result = Number(resultPrice).toFixed(2).slice(1)
    return result
}